<template>
  <v-col class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-buffer"
    ></vuse-section-definition>
    <v-container class=" p-5" fluid>
      <v-row class="mr-4">
        <v-col class="white rounded-lg" cols="12">
          <v-row>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="fieldProject.name"
                    filled
                    label="Name"
                    placeholder="Enter name"
                    @keyup="onKeyUp"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="fieldProject.slug"
                    filled
                    label="Slug"
                    placeholder="Nhập slug"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <div class="my-3">Description</div>
                <ck-content :content="fieldProject.description" class="ck-project"
                            @getData="value => fieldProject.description = value"></ck-content>
              </v-col>
              <v-col cols="12">
                <v-file-input
                    label="Ảnh "
                    placeholder="Tải ảnh lên"
                    prepend-icon="mdi-camera"
                    v-model="image"
                    @change="uploadImg"
                ></v-file-input>
                <div v-if="display_image">
                  <v-img
                      :src="display_image"
                      aspect-ratio="1.7"
                      contain
                  ></v-img>
                </div>
              </v-col>
            </v-col>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="fieldProject.name_vi"
                    filled
                    label="Tên"
                    placeholder="Nhập tên"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-row>
                  <v-col cols="8">
                    <v-text-field
                        v-model="fieldProject.order"
                        filled
                        label="Vị trí"
                        placeholder="Nhập vị trí"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-checkbox
                        v-model="fieldProject.active"
                        label="Active"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <div class="my-3">Mô tả</div>
                <ck-content :content="fieldProject.description_vi" class="ck-project"
                            @getData="value => fieldProject.description_vi = value"></ck-content>
              </v-col>
            </v-col>
          </v-row>

          <v-col cols="12" align="center">
            <v-btn
                color="primary"
                width="180"
                @click="save()"
            >
              Lưu
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import {SAVE_FIELD_PROJECT, UPLOAD_IMAGE} from "@/store/modules/field_project";
import CkContent from "@/components/ck-content";
import validateSlug from "@/mixins/validateSlug";

export default {
  name: "Add_new_feildProject",
  mixins: [validateSlug],
  components: {
    CkContent
  },
  data() {
    return {
      page: "Thêm loại project",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách loại project",
          disabled: true,
        },
        {
          text: "Thêm loại project",
          disabled: false,
        },
      ],
      image: null,
      display_image: '',


      fieldProject: {
        name: '',
        name_vi: '',
        slug: '',
        description: '',
        description_vi: '',
        photo_url: '',
        active: false,
        order: 0
      },
    }
  },
  methods: {
    onKeyUp(value) {
      this.fieldProject.slug = this.sanitizeTitle(value.target.value)
    },
    uploadImg(e) {
      if (e) {
        this.display_image = URL.createObjectURL(e)
      }
      this.$forceUpdate()
    },

    async save() {
      let formDateAvatar = new FormData();
      formDateAvatar.append("upload", this.image);
      formDateAvatar.append("type", "ckeditor");
      formDateAvatar.append("position_type", "1");
      await this.$store.dispatch(`${UPLOAD_IMAGE}`, formDateAvatar).then((data) => {
            if (data.data.status == 1) {
              this.fieldProject.photo_url = data.data.data[0].path
            }
          }
      )
      let data = {
        name: this.fieldProject.name,
        name_vi: this.fieldProject.name_vi,
        slug: this.fieldProject.slug,
        description: this.fieldProject.description,
        description_vi: this.fieldProject.description_vi,
        photo_url: this.fieldProject.photo_url,
        active: this.fieldProject.active ? '1' : '0',
        order: this.fieldProject.order
      }
      await this.$store.dispatch(`${SAVE_FIELD_PROJECT}`, data).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/project_management/field_project')
        }
      });
    }
  }
}
</script>

<style scoped>

</style>